// extracted by mini-css-extract-plugin
export default {"section":"FolderProgress_section__jiZM0","row":"FolderProgress_row__WgutE","col":"FolderProgress_col__3-vBo","card":"FolderProgress_card__50SP5"};